const CATEGORY_PAGE_QUERY_KEY = "CategoryPageQuery";

export const createCategoryPageQueryKeyPrefix = ({
  navigationPath,
}: {
  navigationPath: string;
}) => {
  return [CATEGORY_PAGE_QUERY_KEY, navigationPath] as const;
};
